module.exports = __webpack_public_path__ + "img/kh1@2x.5feb7fd6.png";